import { render, staticRenderFns } from "./GerenciarCompras.vue?vue&type=template&id=2d4c60e1&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./GerenciarCompras.vue?vue&type=style&index=0&id=2d4c60e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4c60e1",
  null
  
)

export default component.exports